import { render, staticRenderFns } from "./NaplataTrafficLight.vue?vue&type=template&id=b2df1c6a&scoped=true"
import script from "./NaplataTrafficLight.vue?vue&type=script&lang=js"
export * from "./NaplataTrafficLight.vue?vue&type=script&lang=js"
import style0 from "./NaplataTrafficLight.vue?vue&type=style&index=0&id=b2df1c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2df1c6a",
  null
  
)

export default component.exports